import { render, staticRenderFns } from "./TripsImagePresentation.vue?vue&type=template&id=787fee45&scoped=true"
import script from "./TripsImagePresentation.vue?vue&type=script&lang=js"
export * from "./TripsImagePresentation.vue?vue&type=script&lang=js"
import style0 from "./TripsImagePresentation.vue?vue&type=style&index=0&id=787fee45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787fee45",
  null
  
)

export default component.exports